export const graphColors = [
  ["#003366"],
  ["#003366", "#D3741C"],
  ["#003366", "#4A76A2", "#D3741C"],
  ["#003366", "#4A76A2", "#D3741C", "#EBB078"],
  ["#000033", "#003366", "#4A76A2", "#D3741C", "#EBB078"],
  ["#000033", "#003366", "#4A76A2", "#AF631C", "#D3741C", "#EBB078"],
  ["#000033", "#003366", "#4A76A2", "#95B9DC", "#AF631C", "#D3741C", "#EBB078"],
  ["#000033", "#003366", "#4A76A2", "#95B9DC", "#AF631C", "#D3741C", "#EBB078", "#FFD0A3"],
];

export const hexToRgb = (hex: string, opacity?: number) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (result) {
    const rgb = {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    };

    const opacityValue = opacity !== undefined ? `, ${opacity}` : "";

    return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b}${opacityValue})`;
  }

  return undefined;
};
